import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getSortState } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Table } from 'reactstrap';

import { Container } from '@mui/material';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntities } from './sensor-data-daily.reducer';

export const SensorDataDaily = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const sensorDataDailyList = useAppSelector(state => state.sensorDataDaily.entities);
  const loading = useAppSelector(state => state.sensorDataDaily.loading);
  const totalItems = useAppSelector(state => state.sensorDataDaily.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.replace(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  console.warn(sensorDataDailyList);

  return (
    <Container>
      <h2 id="sensor-data-daily-heading" data-cy="SensorDataDailyHeading">
        <Translate contentKey="fleetSenseApp.sensorDataDaily.home.title">Sensor Data Dailies</Translate>
        <div className="d-flex justify-content-end">
          <Button className="mr-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} /> <Translate contentKey="fleetSenseApp.sensorDataDaily.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="fleetSenseApp.sensorDataDaily.home.createLabel">Create new Sensor Data Daily</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {sensorDataDailyList && sensorDataDailyList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fleetSenseApp.sensorDataDaily.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('value')}>
                  <Translate contentKey="fleetSenseApp.sensorDataDaily.value">Value</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('created')}>
                  <Translate contentKey="fleetSenseApp.sensorDataDaily.created">Created</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.sensorDataDaily.sensor">Sensor</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.sensorDataDaily.truckImplement">Truck Implement</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                {/* <th>
                  <Translate contentKey="fleetSenseApp.sensorDataDaily.company">Company</Translate> <FontAwesomeIcon icon="sort" />
                </th> */}
                <th />
              </tr>
            </thead>
            <tbody>
              {sensorDataDailyList.map((sensorDataDaily, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${sensorDataDaily.id}`} color="link" size="sm">
                      {sensorDataDaily.id}
                    </Button>
                  </td>
                  <td>{sensorDataDaily.value}</td>
                  <td>{sensorDataDaily.created ? <TextFormat type="date" value={sensorDataDaily.created} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{sensorDataDaily.sensor ? <Link to={`sensor/${sensorDataDaily.sensor.id}`}>{sensorDataDaily.sensor.name}</Link> : ''}</td>
                  <td>
                    {sensorDataDaily.truckImplement ? (
                      <Link to={`truck-implement/${sensorDataDaily.truckImplement.id}`}>{sensorDataDaily.truckImplement.licensePlate}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  {/* <td>
                    {sensorDataDaily.company ? (
                      <Link to={`company/${sensorDataDaily.company.id}`}>{sensorDataDaily.company.name}</Link>
                    ) : (
                      ''
                    )}
                  </td> */}
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${sensorDataDaily.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${sensorDataDaily.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${sensorDataDaily.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.sensorDataDaily.home.notFound">No Sensor Data Dailies found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={sensorDataDailyList && sensorDataDailyList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </Container>
  );
};

export default SensorDataDaily;
